import { createSearchParams } from 'react-router-dom'

const paths = {
  app: {
    root: {
      path: '/',
      getHref: () => '/',
    },
    dashboard: {
      path: 'apps',
      getHref: () => '/apps',
    },
    stock: {
      root: {
        path: 'stock',
        getHref: () => '/stock',
      },
      parts: {
        root: {
          path: 'parts',
          getHref: () => '/stock/parts',
        },
        list: {
          path: '',
          getHref: () => '/stock/parts',
        },
        new: {
          path: 'new',
          getHref: () => '/stock/parts/new',
        },
        part: {
          root: {
            path: ':id',
            getHref: (id: string) => `/stock/parts/${id}`,
          },
          view: {
            path: '',
            getHref: (id: string) => `/stock/parts/${id}`,
          },
          edit: {
            path: 'edit',
            getHref: (id: string) => `/stock/parts/${id}/edit`,
          },
        },
      },
      scraps: {
        root: {
          path: 'scraps',
          getHref: () => '/stock/scraps',
        },
        list: {
          path: '',
          getHref: () => '/stock/scraps',
        },
        new: {
          path: 'new',
          getHref: () => '/stock/scraps/new',
        },
        scrap: {
          root: {
            path: ':id',
            getHref: (id: string) => `/stock/scraps/${id}`,
          },
          view: {
            path: '',
            getHref: (id: string) => `/stock/scraps/${id}`,
          },
        },
      },
      boxes: {
        root: {
          path: 'boxes',
          getHref: () => '/stock/boxes',
        },
        list: {
          path: '',
          getHref: () => '/stock/boxes',
        },
        import: {
          path: 'import',
          getHref: () => '/stock/boxes/import',
        },
        box: {
          root: {
            path: ':id',
            getHref: (id: string) => `/stock/boxes/${id}`,
          },
          view: {
            path: '',
            getHref: (id: string) => `/stock/boxes/${id}`,
          },
          edit: {
            path: 'edit',
            getHref: (id: string) => `/stock/boxes/${id}/edit`,
          },
        },
      },
    },
    package: {
      root: {
        path: 'package',
        getHref: () => '/package',
      },
      view: {
        path: ':id',
        getHref: (id: string) => `/package/${id}`,
      },
    },
    packaging: {
      root: {
        path: 'packaging',
        getHref: () => '/packaging',
      },
      list: {
        path: '',
        getHref: () => `/packaging`,
      },
      new: {
        path: 'new',
        getHref: () => `/packaging/new`,
      },
      edit: {
        path: ':id',
        getHref: (id: string) => `/packaging/${id}`,
      },
    },
    logistics: {
      root: {
        path: 'logistics',
        getHref: () => `/logistics`,
      },
      list: {
        path: '',
        getHref: () => `/logistics`,
      },
      edit: {
        path: ':id',
        getHref: (id: string) => `/logistics/${id}`,
      },
    },
    received: {
      root: {
        path: 'received',
        getHref: () => '/received',
      },
      list: {
        path: '',
        getHref: () => '/received',
      },
      new: {
        path: 'new',
        getHref: (isStay?: boolean) => {
          const pathname = '/received/new'
          const search = createSearchParams({ ...(isStay ? { stay: '' } : {}) })
          return {
            pathname,
            search,
            total: search.toString() ? `${pathname}?${search.toString()}` : pathname,
          }
        },
      },
      edit: {
        path: ':id',
        getHref: (id: string) => `/received/${id}`,
      },
      open: {
        path: 'open',
        getHref: ({ gtsPackage, isStay }: { gtsPackage?: string; isStay?: boolean } = {}) => {
          const pathname = '/received/open'
          const search = createSearchParams({ ...(gtsPackage ? { gtsPackage } : {}), ...(isStay ? { stay: '' } : {}) })
          return {
            pathname,
            search,
            total: search.toString() ? `${pathname}?${search.toString()}` : pathname,
          }
        },
      },
    },
    deviations: {
      root: {
        path: 'deviations',
        getHref: () => `/deviations`,
      },
      list: {
        path: '',
        getHref: () => `/deviations`,
      },
      edit: {
        path: ':id',
        getHref: (id: string) => `/deviations/${id}`,
      },
    },
    incidents: {
      path: 'incidents',
      getHref: () => `/incidents`,
    },
    allLocalPackages: {
      path: 'allLocalPackages',
      getHref: () => `/allLocalPackages`,
    },
    locations: {
      path: 'locations',
      getHref: () => '/locations',
    },
  },
  admin: {
    root: {
      path: 'global-security',
      getHref: () => `/global-security`,
    },
    dashboard: {
      path: '',
      getHref: () => '/global-security',
    },
    parts: {
      root: {
        path: 'parts',
        getHref: () => '/global-security/parts',
      },
      list: {
        path: '',
        getHref: () => '/global-security/parts',
      },
      part: {
        root: {
          path: ':id',
        },
        view: {
          path: '',
          getHref: (id: string) => `/global-security/parts/${id}`,
        },
        edit: {
          path: 'edit',
          getHref: (id: string) => `/global-security/parts/${id}/edit`,
        },
      },
    },
    packages: {
      root: {
        path: 'packages',
        getHref: () => '/global-security/packages',
      },
      list: {
        path: '',
        getHref: () => '/global-security/packages',
      },
      view: {
        path: ':id',
        getHref: (id: string) => `/global-security/packages/${id}`,
      },
    },
    incidents: {
      path: 'incidents',
      getHref: () => '/global-security/incidents',
    },
    statistics: {
      path: 'statistics',
      getHref: () => '/global-security/statistics',
    },
    locations: {
      path: 'locations',
      getHref: () => '/global-security/locations',
    },
    users: {
      path: 'users',
      getHref: () => '/global-security/users',
    },
    settings: {
      root: {
        path: 'settings',
        getHref: () => '/global-security/settings/custom-properties',
      },
      customProperties: {
        path: 'custom-properties',
        getHref: () => `/global-security/settings/custom-properties`,
      },
    },
  },
} as const

export { paths }
